module.exports = __webpack_public_path__ + "static/media/2.ebf03b10.png";